const linkLandingPagesHR = {
    "view": {
        "table": {
            "title": "Vaše odredišne stranice za poveznice",
            "column": {
                "title": "Naslov",
                "description": "Opis",
                "backUrl": "Povratni URL",
                "created": "Stvoreno",
                "landingPage": "Odredišna stranica",
                "action": "Akcija"
            },
            "label": {
                "landingPage": "Odredišna stranica"
            },
            "button": {
                "view": "Pregled",
                "export_csv": "Izvoz CSV"
            },
            "placeholder": {
                "search": "Pretraži..."
            },
            "message": {
                "linkCopied": "Poveznica kopirana u međuspremnik!"
            }
        },
        "modal": {
            "edit": {
                "header": "Uredi {{linkLandingPageName}}?",
                "body": "Jeste li sigurni da želite urediti ovu odredišnu stranicu za poveznice?"
            },
            "delete": {
                "header": "Izbriši {{linkLandingPageName}}?",
                "body": "Jeste li sigurni da želite izbrisati ovu odredišnu stranicu za poveznice?"
            }
        },
        "message": {
            "success": "Odredišna stranica za poveznice je uklonjena!",
            "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovno!",
            "llpAllowanceSpent": "Iskoristili ste svoju kvotu za odredišne stranice za poveznice. Kako biste stvorili više odredišnih stranica za poveznice, nadogradite svoj račun ili kontaktirajte naš tim za podršku.",
            "subscriptionFeatureUnavailable": "Vaš trenutni plan pretplate ne podržava ovu značajku. Molimo <1>nadogradite</1> svoj plan pretplate kako biste iskoristili ovu značajku.",
            "subscriptionExpired": "Vaša pretplata je istekla. Molimo <1>nastavite</1> svoju pretplatu kako biste iskoristili ovu značajku.",
            "noAccess": "Nemate pristup ovom modulu, molimo kontaktirajte tim za podršku za dodatne informacije."
        }
    },
    "add": {
        "title": "Dodaj odredišnu stranicu za poveznice",
        "form": {
            "label": {
                "domain": "Domena",
                "title": "Naslov",
                "backUrl": "Povratni URL",
                "shortDescription": "Kratki opis",
                "logo": "Logo",
                "backgroundImage": "Pozadinska slika",
                "blurredBackground": "Zamućena pozadina",
                "blurred": "Zamućeno",
                "notBlurred": "Nije zamućeno",
                "blurStrength": "Jačina zamućenja",
                "layout": "Izgled",
                "font": "Font",
                "socialIconPlacement": "Položaj ikona društvenih mreža",
                "socialIconColor": "Boja ikona društvenih mreža",
                "buttonCorners": "Kutovi gumba",
                "buttonStyle": "Stil gumba",
                "colorCustomisation": "Prilagodba boja",
                "premadeColors": "Unaprijed izrađene boje",
                "customColors": "Prilagođene boje",
                "headerBackground": "Pozadina zaglavlja",
                "singleColor": "Jednobojna",
                "gradient": "Gradijent",
                "bodyBackground": "Pozadina tijela",
                "titleColor": "Boja naslova",
                "descriptionColor": "Boja opisa",
                "buttonColor": "Boja gumba",
                "buttonTextColor": "Boja teksta gumba",
                "backgroundColor": "Boja pozadine"
            },
            "placeholder": {
                "domain": "Odaberite domenu",
                "shortDescription": "Nekoliko riječi o vašoj odredišnoj stranici. Maksimalno 80 znakova"
            },
            "help_text": {
                "domain": "Odaberite domenu za koju želite stvoriti odredišnu stranicu za poveznice.",
                "logo": "Prenesite JPG ili PNG formate, rezolucija najmanje 500x500 px",
                "backgroundImage": "Prenesite JPG ili PNG formate, rezolucija 1000x1000 px"
            },
            "options": {
                "layout": {
                    "layoutOne": "Izgled jedan",
                    "layoutTwo": "Izgled dva"
                },
                "socialIconPlacement": {
                    "header": "Zaglavlje",
                    "bottomOfTheBody": "Dno tijela"
                },
                "socialIconColor": {
                    "color": "Boja",
                    "black": "Crna",
                    "white": "Bijela"
                },
                "buttonCorners": {
                    "rounded": "Zaobljeni",
                    "semiRounded": "Poluzaobljeni",
                    "squared": "Kvadratni"
                },
                "buttonStyle": {
                    "outlined": "Obrisan",
                    "filled": "Ispunjen"
                }
            },
            "button": {
                "submit": "Pošalji"
            },
            "validation": {
                "formInvalid": "Obrazac se ne može poslati! Ispunite sva polja i provjerite pogreške!",
                "storeUrlRequired": "{{store}} URL je obavezan",
                "storeUrlValid": "Dodajte valjani {{store}} URL."
            }
        },
        "message": {
            "success": "Odredišna stranica za poveznice je dodana!",
            "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovno!"
        },
        "modal": {
            "add": {
                "header": "Dodaj odredišnu stranicu {{title}}?",
                "body": "Jeste li sigurni da želite stvoriti odredišnu stranicu za poveznice s naslovom {{title}}?"
            }
        }
    },
    "update": {
        "title": "Ažuriraj odredišnu stranicu za poveznice",
        "form": {
            "label": {
                "domain": "Domena",
                "title": "Naslov",
                "backUrl": "Povratni URL",
                "shortDescription": "Kratki opis",
                "logo": "Logo",
                "backgroundImage": "Pozadinska slika",
                "blurredBackground": "Zamućena pozadina",
                "blurred": "Zamućeno",
                "notBlurred": "Nije zamućeno",
                "blurStrength": "Jačina zamućenja",
                "layout": "Izgled",
                "font": "Font",
                "socialIconPlacement": "Položaj ikona društvenih mreža",
                "socialIconColor": "Boja ikona društvenih mreža",
                "buttonCorners": "Kutovi gumba",
                "buttonStyle": "Stil gumba",
                "colorCustomisation": "Prilagodba boja",
                "premadeColors": "Unaprijed izrađene boje",
                "customColors": "Prilagođene boje",
                "headerBackground": "Pozadina zaglavlja",
                "singleColor": "Jednobojna",
                "gradient": "Gradijent",
                "bodyBackground": "Pozadina tijela",
                "titleColor": "Boja naslova",
                "descriptionColor": "Boja opisa",
                "buttonColor": "Boja gumba",
                "buttonTextColor": "Boja teksta gumba",
                "backgroundColor": "Boja pozadine"
            },
            "placeholder": {
                "domain": "Odaberite domenu",
                "shortDescription": "Nekoliko riječi o vašoj odredišnoj stranici. Maksimalno 80 znakova"
            },
            "help_text": {
                "domain": "Odaberite domenu za koju želite stvoriti odredišnu stranicu za poveznice.",
                "logo": "Prenesite JPG ili PNG formate, rezolucija najmanje 500x500 px",
                "backgroundImage": "Prenesite JPG ili PNG formate, rezolucija 1000x1000 px"
            },
            "options": {
                "layout": {
                    "layoutOne": "Izgled jedan",
                    "layoutTwo": "Izgled dva"
                },
                "socialIconPlacement": {
                    "header": "Zaglavlje",
                    "bottomOfTheBody": "Dno tijela"
                },
                "socialIconColor": {
                    "color": "Boja",
                    "black": "Crna",
                    "white": "Bijela"
                },
                "buttonCorners": {
                    "rounded": "Zaobljeni",
                    "semiRounded": "Poluzaobljeni",
                    "squared": "Kvadratni"
                },
                "buttonStyle": {
                    "outlined": "Obrisan",
                    "filled": "Ispunjen"
                },
                "platform": {
                    "instagram": "Instagram",
                    "facebook": "Facebook",
                    "twitter": "Twitter",
                    "linkedin": "LinkedIn",
                    "tiktok": "TikTok",
                    "youtube": "YouTube",
                    "other": "Ostalo"
                }
            },
            "button": {
                "submit": "Pošalji"
            }
        },
        "message": {
            "success": "Odredišna stranica za poveznice je ažurirana!",
            "error": "Nešto je pošlo po zlu! Osvježite stranicu i pokušajte ponovno!"
        },
        "modal": {
            "update": {
                "header": "Ažuriraj odredišnu stranicu {{title}}?",
                "body": "Jeste li sigurni da želite ažurirati odredišnu stranicu za poveznice s naslovom {{title}}?"
            }
        }
    },
    "socialLinksRow": {
        "title": "Društvene poveznice",
        "label": {
            "order": "Redoslijed",
            "platform": "Platforma",
            "destinationUrl": "Odredišni URL"
        },
        "options": {
            "platform": {
                "instagram": "Instagram",
                "facebook": "Facebook",
                "twitter": "Twitter",
                "linkedin": "LinkedIn",
                "tiktok": "TikTok",
                "youtube": "YouTube",
                "other": "Ostalo"
            }
        },
        "button": {
            "remove": "Ukloni",
            "add": "Dodaj još jedan"
        }
    },
    "featuredLinksRow": {
        "title": "Istaknute poveznice",
        "label": {
            "order": "Redoslijed",
            "label": "Oznaka",
            "destinationUrl": "Odredišni URL"
        },
        "button": {
            "remove": "Ukloni",
            "add": "Dodaj još jedan"
        }
    },
    "viewAnalytics": {
        "label": {
            "fetchingAnalytics": "Dohvaćanje analitike za glazbenu poveznicu"
        },
        "button": {
            "last7Days": "Posljednjih 7 dana",
            "last14Days": "Posljednjih 14 dana",
            "last30Days": "Posljednjih 30 dana"
        },
        "linkLandingPageViews": {
            "title": "Pregledi odredišne stranice za poveznice",
            "subtitle": "Ukupno pregleda",
            "label": {
                "views": "Pregledi"
            }
        },
        "socialLinkClicks": {
            "title": "Klikovi na društvene poveznice",
            "subtitle": "Ukupno klikova",
            "table": {
                "column": {
                    "platform": "Platforma",
                    "destinationUrl": "Odredišni URL",
                    "clicks": "Klikovi",
                    "clicksPct": "Klikovi (%)"
                }
            }
        },
        "featuredLinkClicks": {
            "title": "Klikovi na istaknute poveznice",
            "subtitle": "Ukupno klikova",
            "table": {
                "column": {
                    "label": "Oznaka",
                    "destinationUrl": "Odredišni URL",
                    "clicks": "Klikovi",
                    "clicksPct": "Klikovi (%)"
                }
            }
        },
        "topTerritories": {
            "title": "Najbolja područja",
            "subtitle": "Ukupno pregleda",
            "table": {
                "column": {
                    "territory": "Područje",
                    "views": "Pregledi",
                    "viewsPct": "Pregledi (%)"
                },
                "label": {
                    "otherTerritories": "Ostala područja"
                }
            }
        },
        "topBrowsers": {
            "title": "Najbolji preglednici",
            "subtitle": "Ukupno pregleda",
            "table": {
                "column": {
                    "browser": "Preglednik",
                    "views": "Pregledi",
                    "viewsPct": "Pregledi (%)"
                }
            }
        },
        "topDeviceTypes": {
            "title": "Najbolje vrste uređaja",
            "table": {
                "column": {}
            }
        },
        "topOperatingSystems": {
            "title": "Najbolji operacijski sustavi",
            "label": {
                "os": "Operacijski sustav",
                "views": "Pregledi"
            }
        }
    }
};

export default linkLandingPagesHR;